import React from 'react';
import styles from './index.module.scss';

const Spacer: React.FC = () => {
    return <div className={styles.root} />;
};

export default Spacer;
